/* ---------------------- BOOKINGS V2 - AIRPORT TRANSFER ---------------------- */

/* ----------------- ASSIGN CHAUFFEUR ----------------- */
export const ASSIGN_CHAUFFEUR = `ASSIGN_CHAUFFEUR`;
export const ASSIGN_CHAUFFEUR_SUCCESS = `ASSIGN_CHAUFFEUR_SUCCESS`;
export const ASSIGN_CHAUFFEUR_ERROR = `ASSIGN_CHAUFFEUR_ERROR`;
export const ASSIGN_CHAUFFEUR_EMPTY = `ASSIGN_CHAUFFEUR_EMPTY`;

/* ----------------- BOOKING ASSIGN TO ME ----------------- */
export const BOOKING_ASSIGN_TO_ME = `BOOKING_ASSIGN_TO_ME`;
export const BOOKING_ASSIGN_TO_ME_SUCCESS = `BOOKING_ASSIGN_TO_ME_SUCCESS`;
export const BOOKING_ASSIGN_TO_ME_ERROR = `BOOKING_ASSIGN_TO_ME_ERROR`;
export const BOOKING_ASSIGN_TO_ME_EMPTY = `BOOKING_ASSIGN_TO_ME_EMPTY`;

/* ----------------- ASSIGN VENDOR ----------------- */
export const ASSIGN_VENDOR = `ASSIGN_VENDOR`;
export const ASSIGN_VENDOR_SUCCESS = `ASSIGN_VENDOR_SUCCESS`;
export const ASSIGN_VENDOR_ERROR = `ASSIGN_VENDOR_ERROR`;
export const ASSIGN_VENDOR_EMPTY = `ASSIGN_VENDOR_EMPTY`;

/* ----------------- CANCEL BOOKING BY VENDOR ----------------- */
export const CANCEL_BOOKING_BY_VENDOR = `CANCEL_BOOKING_BY_VENDOR`;
export const CANCEL_BOOKING_BY_VENDOR_SUCCESS = `CANCEL_BOOKING_BY_VENDOR_SUCCESS`;
export const CANCEL_BOOKING_BY_VENDOR_ERROR = `CANCEL_BOOKING_BY_VENDOR_ERROR`;
export const CANCEL_BOOKING_BY_VENDOR_EMPTY = `CANCEL_BOOKING_BY_VENDOR_EMPTY`;

/* ----------------- CANCELLATION REMARKS FOR VENDOR ----------------- */
export const CANCELLATION_REMARKS_FOR_VENDOR = `CANCELLATION_REMARKS_FOR_VENDOR`;
export const CANCELLATION_REMARKS_FOR_VENDOR_SUCCESS = `CANCELLATION_REMARKS_FOR_VENDOR_SUCCESS`;
export const CANCELLATION_REMARKS_FOR_VENDOR_ERROR = `CANCELLATION_REMARKS_FOR_VENDOR_ERROR`;
export const CANCELLATION_REMARKS_FOR_VENDOR_EMPTY = `CANCELLATION_REMARKS_FOR_VENDOR_EMPTY`;

/* ----------------- CONFRIM BOOKING BY VENDOR ----------------- */
export const CONFIRM_BOOKING_BY_VENDOR = `CONFIRM_BOOKING_BY_VENDOR`;
export const CONFIRM_BOOKING_BY_VENDOR_SUCCESS = `CONFIRM_BOOKING_BY_VENDOR_SUCCESS`;
export const CONFIRM_BOOKING_BY_VENDOR_ERROR = `CONFIRM_BOOKING_BY_VENDOR_ERROR`;
export const CONFIRM_BOOKING_BY_VENDOR_EMPTY = `CONFIRM_BOOKING_BY_VENDOR_EMPTY`;

/* ----------------- BULK CONFRIM BOOKING BY VENDOR ----------------- */
export const BULK_CONFIRM_BOOKING_BY_VENDOR = `BULK_CONFIRM_BOOKING_BY_VENDOR`;
export const BULK_CONFIRM_BOOKING_BY_VENDOR_SUCCESS = `BULK_CONFIRM_BOOKING_BY_VENDOR_SUCCESS`;
export const BULK_CONFIRM_BOOKING_BY_VENDOR_ERROR = `BULK_CONFIRM_BOOKING_BY_VENDOR_ERROR`;
export const BULK_CONFIRM_BOOKING_BY_VENDOR_EMPTY = `BULK_CONFIRM_BOOKING_BY_VENDOR_EMPTY`;

/* ----------------- CREATE CHAUFFEUR ----------------- */
export const CREATE_CHAUFFEUR = `CREATE_CHAUFFEUR`;
export const CREATE_CHAUFFEUR_SUCCESS = `CREATE_CHAUFFEUR_SUCCESS`;
export const CREATE_CHAUFFEUR_ERROR = `CREATE_CHAUFFEUR_ERROR`;
export const CREATE_CHAUFFEUR_EMPTY = `CREATE_CHAUFFEUR_EMPTY`;

/* ----------------- GET CARS LIST OF VENDOR ----------------- */
export const GET_CARS_LIST_OF_VENDOR = `GET_CARS_LIST_OF_VENDOR`;
export const GET_CARS_LIST_OF_VENDOR_SUCCESS = `GET_CARS_LIST_OF_VENDOR_SUCCESS`;
export const GET_CARS_LIST_OF_VENDOR_ERROR = `GET_CARS_LIST_OF_VENDOR_ERROR`;
export const GET_CARS_LIST_OF_VENDOR_EMPTY = `GET_CARS_LIST_OF_VENDOR_EMPTY`;

/* ----------------- GET CHAUFFEURS LIST ----------------- */
export const GET_CHAUFFEURS_LIST = `GET_CHAUFFEURS_LIST`;
export const GET_CHAUFFEURS_LIST_SUCCESS = `GET_CHAUFFEURS_LIST_SUCCESS`;
export const GET_CHAUFFEURS_LIST_ERROR = `GET_CHAUFFEURS_LIST_ERROR`;
export const GET_CHAUFFEURS_LIST_EMPTY = `GET_CHAUFFEURS_LIST_EMPTY`;

/* ----------------- GET VENDORS LIST DATA ----------------- */
export const GET_VENDORS_LIST_DATA = `GET_VENDORS_LIST_DATA`;
export const GET_VENDORS_LIST_DATA_SUCCESS = `GET_VENDORS_LIST_DATA_SUCCESS`;
export const GET_VENDORS_LIST_DATA_ERROR = `GET_VENDORS_LIST_DATA_ERROR`;
export const GET_VENDORS_LIST_DATA_EMPTY = `GET_VENDORS_LIST_DATA_EMPTY`;

/* ----------------- ASSIGN VENDOR REMARKS LIST ----------------- */
export const ASSIGN_VENDOR_REMARKS_LIST = `ASSIGN_VENDOR_REMARKS_LIST`;
export const ASSIGN_VENDOR_REMARKS_LIST_SUCCESS = `ASSIGN_VENDOR_REMARKS_LIST_SUCCESS`;
export const ASSIGN_VENDOR_REMARKS_LIST_ERROR = `ASSIGN_VENDOR_REMARKS_LIST_ERROR`;
export const ASSIGN_VENDOR_REMARKS_LIST_EMPTY = `ASSIGN_VENDOR_REMARKS_LIST_EMPTY`;

/* ----------------- GET BOOKINGS LIST ----------------- */
export const GET_BOOKINGS_LIST = `GET_BOOKINGS_LIST`;
export const GET_BOOKINGS_LIST_SUCCESS = `GET_BOOKINGS_LIST_SUCCESS`;
export const GET_BOOKINGS_LIST_ERROR = `GET_BOOKINGS_LIST_ERROR`;
export const GET_BOOKINGS_LIST_EMPTY = `GET_BOOKINGS_LIST_EMPTY`;

/* ----------------- GET BOOKING DETAILS ----------------- */
export const GET_BOOKING_DETAILS = `GET_BOOKING_DETAILS`;
export const GET_BOOKING_DETAILS_SUCCESS = `GET_BOOKING_DETAILS_SUCCESS`;
export const GET_BOOKING_DETAILS_ERROR = `GET_BOOKING_DETAILS_ERROR`;
export const GET_BOOKING_DETAILS_EMPTY = `GET_BOOKING_DETAILS_EMPTY`;

/* ----------------- GET FILTERS LIST ----------------- */
export const GET_FILTERS_LIST = `GET_FILTERS_LIST`;
export const GET_FILTERS_LIST_SUCCESS = `GET_FILTERS_LIST_SUCCESS`;
export const GET_FILTERS_LIST_ERROR = `GET_FILTERS_LIST_ERROR`;
export const GET_FILTERS_LIST_EMPTY = `GET_FILTERS_LIST_EMPTY`;

/* ----------------- GET FILTER VALUES ----------------- */
export const GET_FILTER_VALUES = `GET_FILTER_VALUES`;
export const GET_FILTER_VALUES_SUCCESS = `GET_FILTER_VALUES_SUCCESS`;
export const GET_FILTER_VALUES_ERROR = `GET_FILTER_VALUES_ERROR`;
export const GET_FILTER_VALUES_EMPTY = `GET_FILTER_VALUES_EMPTY`;

// GET BOOKING TYPE
export const GET_BOOKING_TYPE = `GET_BOOKING_TYPE`;
export const GET_BOOKING_TYPE_SUCCESS = `GET_BOOKING_TYPE_SUCCESS`;
export const GET_BOOKING_TYPE_ERROR = `GET_BOOKING_TYPE_ERROR`;
export const GET_BOOKING_TYPE_EMPTY = `GET_BOOKING_TYPE_EMPTY`;

// GET V2 DASHBOARD
export const GET_DASHBOARD = `GET_DASHBOARD`;
export const GET_DASHBOARD_SUCCESS = `GET_DASHBOARD_SUCCESS`;
export const GET_DASHBOARD_ERROR = `GET_DASHBOARD_ERROR`;
export const GET_DASHBOARD_EMPTY = `GET_DASHBOARD_EMPTY`;

// GET USER ROLES
export const GET_USER_ROLES = `GET_USER_ROLES`;
export const GET_USER_ROLES_SUCCESS = `GET_USER_ROLES_SUCCESS`;
export const GET_USER_ROLES_ERROR = `GET_USER_ROLES_ERROR`;
export const GET_USER_ROLES_EMPTY = `GET_USER_ROLES_EMPTY`;

// GET CARD DETAILS
export const GET_CARD_DETAILS = `GET_CARD_DETAILS`;
export const GET_CARD_DETAILS_SUCCESS = `GET_CARD_DETAILS_SUCCESS`;
export const GET_CARD_DETAILS_ERROR = `GET_CARD_DETAILS_ERROR`;
export const GET_CARD_DETAILS_EMPTY = `GET_CARD_DETAILS_EMPTY`;

/* ----------------- CANCEL BOOKING BY ADMIN ----------------- */
export const CANCEL_BOOKING_BY_ADMIN = `CANCEL_BOOKING_BY_ADMIN`;
export const CANCEL_BOOKING_BY_ADMIN_SUCCESS = `CANCEL_BOOKING_BY_ADMIN_SUCCESS`;
export const CANCEL_BOOKING_BY_ADMIN_ERROR = `CANCEL_BOOKING_BY_ADMIN_ERROR`;
export const CANCEL_BOOKING_BY_ADMIN_EMPTY = `CANCEL_BOOKING_BY_ADMIN_EMPTY`;

/* ----------------- GET BOOKING TYPE FOR GLOBAL SEARCH ----------------- */
export const GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH = `GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH`;
export const GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH_SUCCESS = `GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH_SUCCESS`;
export const GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH_ERROR = `GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH_ERROR`;
export const GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH_EMPTY = `GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH_EMPTY`;

/* ----------------- GET BOOKING FOR GLOBAL SEARCH ----------------- */
export const GET_BOOKING_GLOBAL_SEARCH = `GET_BOOKING_GLOBAL_SEARCH`;
export const GET_BOOKING_GLOBAL_SEARCH_SUCCESS = `GET_BOOKING_GLOBAL_SEARCH_SUCCESS`;
export const GET_BOOKING_GLOBAL_SEARCH_ERROR = `GET_BOOKING_GLOBAL_SEARCH_ERROR`;
export const GET_BOOKING_GLOBAL_SEARCH_EMPTY = `GET_BOOKING_GLOBAL_SEARCH_EMPTY`;

/* ----------------- MODIFY FIELDS ----------------- */
export const SHOW_MODIFY_FIELDS = `SHOW_MODIFY_FIELDS`;
export const SHOW_MODIFY_FIELDS_SUCCESS = `SHOW_MODIFY_FIELDS_SUCCESS`;
export const SHOW_MODIFY_FIELDS_ERROR = `SHOW_MODIFY_FIELDS_ERROR`;
export const SHOW_MODIFY_FIELDS_EMPTY = `SHOW_MODIFY_FIELDS_EMPTY`;

/* ----------------- MODIFY BOOKING ----------------- */
export const MODIFY_BOOKING = `MODIFY_BOOKING`;
export const MODIFY_BOOKING_SUCCESS = `MODIFY_BOOKING_SUCCESS`;
export const MODIFY_BOOKING_ERROR = `MODIFY_BOOKING_ERROR`;
export const MODIFY_BOOKING_EMPTY = `MODIFY_BOOKING_EMPTY`;

/* ----------------- APPROVAL AWAITING ----------------- */
export const APPROVAL_ACTION = `APPROVAL_ACTION`;
export const APPROVAL_ACTION_SUCCESS = `APPROVAL_ACTION_SUCCESS`;
export const APPROVAL_ACTION_ERROR = `APPROVAL_ACTION_ERROR`;
export const APPROVAL_ACTION_EMPTY = `APPROVAL_ACTION_EMPTY`;

/* ----------------- REMARKS STATUS ----------------- */
export const REMARK_STATUS = `REMARK_STATUS`;
export const REMARK_STATUS_SUCCESS = `REMARK_STATUS_SUCCESS`;
export const REMARK_STATUS_ERROR = `REMARK_STATUS_ERROR`;
export const REMARK_STATUS_EMPTY = `REMARK_STATUS_EMPTY`;

/* ----------------- REMARKS STATUS ----------------- */
export const GET_ACTION_BY_STATUS = `GET_ACTION_BY_STATUS`;
export const GET_ACTION_BY_STATUS_SUCCESS = `GET_ACTION_BY_STATUS_SUCCESS`;
export const GET_ACTION_BY_STATUS_ERROR = `GET_ACTION_BY_STATUS_ERROR`;
export const GET_ACTION_BY_STATUS_EMPTY = `GET_ACTION_BY_STATUS_EMPTY`;

/* ----------------- REMARKS STATUS ----------------- */
export const GET_REASON_BY_ACTIONS = `GET_REASON_BY_ACTIONS`;
export const GET_REASON_BY_ACTIONS_SUCCESS = `GET_REASON_BY_ACTIONS_SUCCESS`;
export const GET_REASON_BY_ACTIONS_ERROR = `GET_REASON_BY_ACTIONS_ERROR`;
export const GET_REASON_BY_ACTIONS_EMPTY = `GET_REASON_BY_ACTIONS_EMPTY`;

/* ----------------- REMARKS STATUS ----------------- */
export const ADD_REASON = `ADD_REASON`;
export const ADD_REASON_SUCCESS = `ADD_REASON_SUCCESS`;
export const ADD_REASON_ERROR = `ADD_REASON_ERROR`;
export const ADD_REASON_EMPTY = `ADD_REASON_EMPTY`;

/* ----------------- REMARKS STATUS ----------------- */
export const UPDATE_REASON = `UPDATE_REASON`;
export const UPDATE_REASON_SUCCESS = `UPDATE_REASON_SUCCESS`;
export const UPDATE_REASON_ERROR = `UPDATE_REASON_ERROR`;
export const UPDATE_REASON_EMPTY = `UPDATE_REASON_EMPTY`;

/* ----------------- COMPLETE BOOKING ----------------- */
export const COMPLETE_BOOKING = `COMPLETE_BOOKING`;
export const COMPLETE_BOOKING_SUCCESS = `COMPLETE_BOOKING_SUCCESS`;
export const COMPLETE_BOOKING_ERROR = `COMPLETE_BOOKING_ERROR`;
export const COMPLETE_BOOKING_EMPTY = `COMPLETE_BOOKING_EMPTY`;

/* ----------------- COMPLETE BOOKING ----------------- */
export const COMPLETE_BOOKING_GOLF = `COMPLETE_BOOKING_GOLF`;
export const COMPLETE_BOOKING_GOLF_SUCCESS = `COMPLETE_BOOKING_GOLF_SUCCESS`;
export const COMPLETE_BOOKING_GOLF_ERROR = `COMPLETE_BOOKING_GOLF_ERROR`;
export const COMPLETE_BOOKING_GOLF_EMPTY = `COMPLETE_BOOKING_GOLF_EMPTY`;

/* ----------------- Raise Dispute ----------------- */
export const RAISE_DISPUTE = `RAISE_DISPUTE`;
export const RAISE_DISPUTE_SUCCESS = `RAISE_DISPUTE_SUCCESS`;
export const RAISE_DISPUTE_ERROR = `RAISE_DISPUTE_ERROR`;
export const RAISE_DISPUTE_EMPTY = `RAISE_DISPUTE_EMPTY`;

/* ----------------- Booking Dump Type List ----------------- */
export const GET_BOOKING_DUMP_TYPE_LIST = `GET_BOOKING_DUMP_TYPE_LIST`;
export const GET_BOOKING_DUMP_TYPE_LIST_SUCCESS = `GET_BOOKING_DUMP_TYPE_LIST_SUCCESS`;
export const GET_BOOKING_DUMP_TYPE_LIST_ERROR = `GET_BOOKING_DUMP_TYPE_LIST_ERROR`;
export const GET_BOOKING_DUMP_TYPE_LIST_EMPTY = `GET_BOOKING_DUMP_TYPE_LIST_EMPTY`;

/* ----------------- Post Download Dump ----------------- */
export const DOWNLOAD_DUMP_ADMIN_V2 = `DOWNLOAD_DUMP_ADMIN_V2`;
export const DOWNLOAD_DUMP_ADMIN_V2_SUCCESS = `DOWNLOAD_DUMP_ADMIN_V2_SUCCESS`;
export const DOWNLOAD_DUMP_ADMIN_V2_ERROR = `DOWNLOAD_DUMP_ADMIN_V2_ERROR`;
export const DOWNLOAD_DUMP_ADMIN_V2_EMPTY = `DOWNLOAD_DUMP_ADMIN_V2_EMPTY`;

/* ----------------- Get Download Dump ----------------- */
export const GET_DOWNLOAD_DUMP_ADMIN_V2 = `GET_DOWNLOAD_DUMP_ADMIN_V2`;
export const GET_DOWNLOAD_DUMP_ADMIN_V2_SUCCESS = `GET_DOWNLOAD_DUMP_ADMIN_V2_SUCCESS`;
export const GET_DOWNLOAD_DUMP_ADMIN_V2_ERROR = `GET_DOWNLOAD_DUMP_ADMIN_V2_ERROR`;
export const GET_DOWNLOAD_DUMP_ADMIN_V2_EMPTY = `GET_DOWNLOAD_DUMP_ADMIN_V2_EMPTY`;

// ******************************* AIRPORT TRANSFER *******************************

/* ----------------- GET AIRPORTS BASED ON CONFIG ID ----------------- */
export const GET_AIRPORTS_BASED_ON_CONFIG_ID = `GET_AIRPORTS_BASED_ON_CONFIG_ID`;
export const GET_AIRPORTS_BASED_ON_CONFIG_ID_SUCCESS = `GET_AIRPORTS_BASED_ON_CONFIG_ID_SUCCESS`;
export const GET_AIRPORTS_BASED_ON_CONFIG_ID_ERROR = `GET_AIRPORTS_BASED_ON_CONFIG_ID_ERROR`;
export const GET_AIRPORTS_BASED_ON_CONFIG_ID_EMPTY = `GET_AIRPORTS_BASED_ON_CONFIG_ID_EMPTY`;

/* ----------------- GET RECENT SEARCHES ----------------- */
export const GET_RECENT_SEARCHES = `GET_RECENT_SEARCHES`;
export const GET_RECENT_SEARCHES_SUCCESS = `GET_RECENT_SEARCHES_SUCCESS`;
export const GET_RECENT_SEARCHES_ERROR = `GET_RECENT_SEARCHES_ERROR`;
export const GET_RECENT_SEARCHES_EMPTY = `GET_RECENT_SEARCHES_EMPTY`;

/* ----------------- GET AUTOCOMPLETE LOCATION ----------------- */
export const GET_AUTOCOMPLETE_LOCATION = `GET_AUTOCOMPLETE_LOCATION`;
export const GET_AUTOCOMPLETE_LOCATION_SUCCESS = `GET_AUTOCOMPLETE_LOCATION_SUCCESS`;
export const GET_AUTOCOMPLETE_LOCATION_ERROR = `GET_AUTOCOMPLETE_LOCATION_ERROR`;
export const GET_AUTOCOMPLETE_LOCATION_EMPTY = `GET_AUTOCOMPLETE_LOCATION_EMPTY`;

/* ----------------- VALIDATE LOCATION ----------------- */
export const VALIDATE_LOCATION = `VALIDATE_LOCATION`;
export const VALIDATE_LOCATION_SUCCESS = `VALIDATE_LOCATION_SUCCESS`;
export const VALIDATE_LOCATION_ERROR = `VALIDATE_LOCATION_ERROR`;
export const VALIDATE_LOCATION_EMPTY = `VALIDATE_LOCATION_EMPTY`;

/* ----------------- CREATE GUEST USER ----------------- */
export const CREATE_GUEST_USER = `CREATE_GUEST_USER`;
export const CREATE_GUEST_USER_SUCCESS = `CREATE_GUEST_USER_SUCCESS`;
export const CREATE_GUEST_USER_ERROR = `CREATE_GUEST_USER_ERROR`;
export const CREATE_GUEST_USER_EMPTY = `CREATE_GUEST_USER_EMPTY`;

/* ----------------- GET GUEST USERS ----------------- */
export const GET_GUEST_USERS = `GET_GUEST_USERS`;
export const GET_GUEST_USERS_SUCCESS = `GET_GUEST_USERS_SUCCESS`;
export const GET_GUEST_USERS_ERROR = `GET_GUEST_USERS_ERROR`;
export const GET_GUEST_USERS_EMPTY = `GET_GUEST_USERS_EMPTY`;

/* ----------------- UPDATE GUEST USER ----------------- */
export const UPDATE_GUEST_USER = `UPDATE_GUEST_USER`;
export const UPDATE_GUEST_USER_SUCCESS = `UPDATE_GUEST_USER_SUCCESS`;
export const UPDATE_GUEST_USER_ERROR = `UPDATE_GUEST_USER_ERROR`;
export const UPDATE_GUEST_USER_EMPTY = `UPDATE_GUEST_USER_EMPTY`;

/* ----------------- VALIDATE FLIGHT DETAILS ----------------- */
export const VALIDATE_FLIGHT_DETAILS = `VALIDATE_FLIGHT_DETAILS`;
export const VALIDATE_FLIGHT_DETAILS_SUCCESS = `VALIDATE_FLIGHT_DETAILS_SUCCESS`;
export const VALIDATE_FLIGHT_DETAILS_ERROR = `VALIDATE_FLIGHT_DETAILS_ERROR`;
export const VALIDATE_FLIGHT_DETAILS_EMPTY = `VALIDATE_FLIGHT_DETAILS_EMPTY`;

/* ----------------- GET PAYMENT SUMMARY ----------------- */
export const GET_PAYMENT_SUMMARY = `GET_PAYMENT_SUMMARY`;
export const GET_PAYMENT_SUMMARY_SUCCESS = `GET_PAYMENT_SUMMARY_SUCCESS`;
export const GET_PAYMENT_SUMMARY_ERROR = `GET_PAYMENT_SUMMARY_ERROR`;
export const GET_PAYMENT_SUMMARY_EMPTY = `GET_PAYMENT_SUMMARY_EMPTY`;

/* ----------------- CREATE AIRPORT TRANSFER BOOKING ----------------- */
export const CREATE_AIRPORT_TRANSFER_BOOKING = `CREATE_AIRPORT_TRANSFER_BOOKING`;
export const CREATE_AIRPORT_TRANSFER_BOOKING_SUCCESS = `CREATE_AIRPORT_TRANSFER_BOOKING_SUCCESS`;
export const CREATE_AIRPORT_TRANSFER_BOOKING_ERROR = `CREATE_AIRPORT_TRANSFER_BOOKING_ERROR`;
export const CREATE_AIRPORT_TRANSFER_BOOKING_EMPTY = `CREATE_AIRPORT_TRANSFER_BOOKING_EMPTY`;

/* ----------------- GET BOOKING SUMMARY ----------------- */
export const GET_BOOKING_SUMMARY = `GET_BOOKING_SUMMARY`;
export const GET_BOOKING_SUMMARY_SUCCESS = `GET_BOOKING_SUMMARY_SUCCESS`;
export const GET_BOOKING_SUMMARY_ERROR = `GET_BOOKING_SUMMARY_ERROR`;
export const GET_BOOKING_SUMMARY_EMPTY = `GET_BOOKING_SUMMARY_EMPTY`;

// GET NOTIFICATION BOOKING
export const GET_NOTIFICATION_BOOKING = `GET_NOTIFICATION_BOOKING`;
export const GET_NOTIFICATION_BOOKING_SUCCESS = `GET_NOTIFICATION_BOOKING_SUCCESS`;
export const GET_NOTIFICATION_BOOKING_ERROR = `GET_NOTIFICATION_BOOKING_ERROR`;
export const GET_NOTIFICATION_BOOKING_EMPTY = `GET_NOTIFICATION_BOOKING_EMPTY`;

// GET NOTIFICATION STATUS
export const GET_NOTIFICATION_STATUS = `GET_NOTIFICATION_STATUS`;
export const GET_NOTIFICATION_STATUS_SUCCESS = `GET_NOTIFICATION_STATUS_SUCCESS`;
export const GET_NOTIFICATION_STATUS_ERROR = `GET_NOTIFICATION_STATUS_ERROR`;
export const GET_NOTIFICATION_STATUS_EMPTY = `GET_NOTIFICATION_STATUS_EMPTY`;

// SEND NOTIFICATION
export const SEND_NOTIFICATION = `SEND_NOTIFICATION`;
export const SEND_NOTIFICATION_SUCCESS = `SEND_NOTIFICATION_SUCCESS`;
export const SEND_NOTIFICATION_ERROR = `SEND_NOTIFICATION_ERROR`;
export const SEND_NOTIFICATION_EMPTY = `SEND_NOTIFICATION_EMPTY`;

// REJECT SLOT OPTIONS
export const GET_REJECT_SLOT_OPTIONS = `GET_REJECT_SLOT_OPTIONS`;
export const GET_REJECT_SLOT_OPTIONS_SUCCESS = `GET_REJECT_SLOT_OPTIONS_SUCCESS`;
export const GET_REJECT_SLOT_OPTIONS_ERROR = `GET_REJECT_SLOT_OPTIONS_ERROR`;
export const GET_REJECT_SLOT_OPTIONS_EMPTY = `GET_REJECT_SLOT_OPTIONS_EMPTY`;

// REJECT SLOT OPTIONS
export const GET_REJECT_SLOT_OPTIONS_V2 = `GET_REJECT_SLOT_OPTIONS_V2`;
export const GET_REJECT_SLOT_OPTIONS_V2_SUCCESS = `GET_REJECT_SLOT_OPTIONS_V2_SUCCESS`;
export const GET_REJECT_SLOT_OPTIONS_V2_ERROR = `GET_REJECT_SLOT_OPTIONS_V2_ERROR`;
export const GET_REJECT_SLOT_OPTIONS_V2_EMPTY = `GET_REJECT_SLOT_OPTIONS_V2_EMPTY`;

// REJECT SLOT
export const REJECT_SLOT = `REJECT_SLOT`;
export const REJECT_SLOT_SUCCESS = `REJECT_SLOT_SUCCESS`;
export const REJECT_SLOT_ERROR = `REJECT_SLOT_ERROR`;
export const REJECT_SLOT_EMPTY = `REJECT_SLOT_EMPTY`;

// VALIDATE OTP
export const VALIDATE_OTP = `VALIDATE_OTP`;
export const VALIDATE_OTP_SUCCESS = `VALIDATE_OTP_SUCCESS`;
export const VALIDATE_OTP_ERROR = `VALIDATE_OTP_ERROR`;
export const VALIDATE_OTP_EMPTY = `VALIDATE_OTP_EMPTY`;

// RESEND OTP
export const RESEND_OTP = `RESEND_OTP`;
export const RESEND_OTP_SUCCESS = `RESEND_OTP_SUCCESS`;
export const RESEND_OTP_ERROR = `RESEND_OTP_ERROR`;
export const RESEND_OTP_EMPTY = `RESEND_OTP_EMPTY`;

// SUGGEST GOLF
export const SUGGEST_GOLF = `SUGGEST_GOLF`;
export const SUGGEST_GOLF_SUCCESS = `SUGGEST_GOLF_SUCCESS`;
export const SUGGEST_GOLF_ERROR = `SUGGEST_GOLF_ERROR`;
export const SUGGEST_GOLF_EMPTY = `SUGGEST_GOLF_EMPTY`;

// SUGGEST GOLF
export const ADD_SUGGEST_GOLF = `ADD_SUGGEST_GOLF`;
export const ADD_SUGGEST_GOLF_SUCCESS = `ADD_SUGGEST_GOLF_SUCCESS`;
export const ADD_SUGGEST_GOLF_ERROR = `ADD_SUGGEST_GOLF_ERROR`;
export const ADD_SUGGEST_GOLF_EMPTY = `ADD_SUGGEST_GOLF_EMPTY`;

// GET CLIENT
export const GET_CLIENT_V2 = `GET_CLIENT_V2`;
export const GET_CLIENT_V2_SUCCESS = `GET_CLIENT_V2_SUCCESS`;
export const GET_CLIENT_V2_ERROR = `GET_CLIENT_V2_ERROR`;
export const GET_CLIENT_V2_EMPTY = `GET_CLIENT_V2_EMPTY`;

// GET CLIENT DETAILS
export const GET_CLIENT_DETAILS_V2 = `GET_CLIENT_DETAILS_V2`;
export const GET_CLIENT_DETAILS_V2_SUCCESS = `GET_CLIENT_DETAILS_V2_SUCCESS`;
export const GET_CLIENT_DETAILS_V2_ERROR = `GET_CLIENT_DETAILS_V2_ERROR`;
export const GET_CLIENT_DETAILS_V2_EMPTY = `GET_CLIENT_DETAILS_V2_EMPTY`;

// GET BENEFIT AND BENEFIT GROUP
export const GET_BENEFIT_AND_BENEFIT_GROUP = `GET_BENEFIT_AND_BENEFIT_GROUP`;
export const GET_BENEFIT_AND_BENEFIT_GROUP_SUCCESS = `GET_BENEFIT_AND_BENEFIT_GROUP_SUCCESS`;
export const GET_BENEFIT_AND_BENEFIT_GROUP_ERROR = `GET_BENEFIT_AND_BENEFIT_GROUP_ERROR`;
export const GET_BENEFIT_AND_BENEFIT_GROUP_EMPTY = `GET_BENEFIT_AND_BENEFIT_GROUP_EMPTY`;

// GET PROJECT
export const GET_PROJECT_V2 = `GET_PROJECT_V2`;
export const GET_PROJECT_V2_SUCCESS = `GET_PROJECT_V2_SUCCESS`;
export const GET_PROJECT_V2_ERROR = `GET_PROJECT_V2_ERROR`;
export const GET_PROJECT_V2_EMPTY = `GET_PROJECT_V2_EMPTY`;

// GET CORDINATE
export const GET_COORDINATES = `GET_COORDINATES`;
export const GET_COORDINATES_SUCCESS = `GET_COORDINATES_SUCCESS`;
export const GET_COORDINATES_ERROR = `GET_COORDINATES_ERROR`;
export const GET_COORDINATES_EMPTY = `GET_COORDINATES_EMPTY`;

// GET CARTYPE
export const GET_CAR_TYPE = `GET_CAR_TYPE`;
export const GET_CAR_TYPE_SUCCESS = `GET_CAR_TYPE_SUCCESS`;
export const GET_CAR_TYPE_ERROR = `GET_CAR_TYPE_ERROR`;
export const GET_CAR_TYPE_EMPTY = `GET_CAR_TYPE_EMPTY`;

// GET INVENTORY VIEW
export const GET_INVENTORY_VIEW = `GET_INVENTORY_VIEW`;
export const GET_INVENTORY_VIEW_SUCCESS = `GET_INVENTORY_VIEW_SUCCESS`;
export const GET_INVENTORY_VIEW_ERROR = `GET_INVENTORY_VIEW_ERROR`;
export const GET_INVENTORY_VIEW_EMPTY = `GET_INVENTORY_VIEW_EMPTY`;

// CREATE CLIENT
export const CREATE_CLIENT_V2 = `CREATE_CLIENT_V2`;
export const CREATE_CLIENT_V2_SUCCESS = `CREATE_CLIENT_V2_SUCCESS`;
export const CREATE_CLIENT_V2_ERROR = `CREATE_CLIENT_V2_ERROR`;
export const CREATE_CLIENT_V2_EMPTY = `CREATE_CLIENT_V2_EMPTY`;

// CREATE VENDOR
export const CREATE_VENDOR_V2 = `CREATE_VENDOR_V2`;
export const CREATE_VENDOR_V2_SUCCESS = `CREATE_VENDOR_V2_SUCCESS`;
export const CREATE_VENDOR_V2_ERROR = `CREATE_VENDOR_V2_ERROR`;
export const CREATE_VENDOR_V2_EMPTY = `CREATE_VENDOR_V2_EMPTY`;

// CREATE ZONES
export const CREATE_ZONES_V2 = `CREATE_ZONES_V2`;
export const CREATE_ZONES_V2_SUCCESS = `CREATE_ZONES_V2_SUCCESS`;
export const CREATE_ZONES_V2_ERROR = `CREATE_ZONES_V2_ERROR`;
export const CREATE_ZONES_V2_EMPTY = `CREATE_ZONES_V2_EMPTY`;

// CREATE AIRPORT
export const CREATE_AIRPORT_V2 = `CREATE_AIRPORT_V2`;
export const CREATE_AIRPORT_V2_SUCCESS = `CREATE_AIRPORT_V2_SUCCESS`;
export const CREATE_AIRPORT_V2_ERROR = `CREATE_AIRPORT_V2_ERROR`;
export const CREATE_AIRPORT_V2_EMPTY = `CREATE_AIRPORT_V2_EMPTY`;

// UPDATE AIRPORT
export const UPDATE_AIRPORT_V2 = `UPDATE_AIRPORT_V2`;
export const UPDATE_AIRPORT_V2_SUCCESS = `UPDATE_AIRPORT_V2_SUCCESS`;
export const UPDATE_AIRPORT_V2_ERROR = `UPDATE_AIRPORT_V2_ERROR`;
export const UPDATE_AIRPORT_V2_EMPTY = `UPDATE_AIRPORT_V2_EMPTY`;

// UPDATE CLIENT
export const UPDATE_CLIENT_V2 = `UPDATE_CLIENT_V2`;
export const UPDATE_CLIENT_V2_SUCCESS = `UPDATE_CLIENT_V2_SUCCESS`;
export const UPDATE_CLIENT_V2_ERROR = `UPDATE_CLIENT_V2_ERROR`;
export const UPDATE_CLIENT_V2_EMPTY = `UPDATE_CLIENT_V2_EMPTY`;

// UPDATE ZONES
export const UPDATE_ZONES_V2 = `UPDATE_ZONES_V2`;
export const UPDATE_ZONES_V2_SUCCESS = `UPDATE_ZONES_V2_SUCCESS`;
export const UPDATE_ZONES_V2_ERROR = `UPDATE_ZONES_V2_ERROR`;
export const UPDATE_ZONES_V2_EMPTY = `UPDATE_ZONES_V2_EMPTY`;

// UPDATE VENDOR
export const UPDATE_VENDOR_V2 = `UPDATE_VENDOR_V2`;
export const UPDATE_VENDOR_V2_SUCCESS = `UPDATE_VENDOR_V2_SUCCESS`;
export const UPDATE_VENDOR_V2_ERROR = `UPDATE_VENDOR_V2_ERROR`;
export const UPDATE_VENDOR_V2_EMPTY = `UPDATE_VENDOR_V2_EMPTY`;

// SAVE AS DRAFT
export const SAVE_DRAFT_CONFIGURATION = `SAVE_DRAFT_CONFIGURATION`;
export const SAVE_DRAFT_CONFIGURATION_SUCCESS = `SAVE_DRAFT_CONFIGURATION_SUCCESS`;
export const SAVE_DRAFT_CONFIGURATION_ERROR = `SAVE_DRAFT_CONFIGURATION_ERROR`;
export const SAVE_DRAFT_CONFIGURATION_EMPTY = `SAVE_DRAFT_CONFIGURATION_EMPTY`;

// UPDATE AS DRAFT
export const UPDATE_DRAFT_CONFIGURATION = `UPDATE_DRAFT_CONFIGURATION`;
export const UPDATE_DRAFT_CONFIGURATION_SUCCESS = `UPDATE_DRAFT_CONFIGURATION_SUCCESS`;
export const UPDATE_DRAFT_CONFIGURATION_ERROR = `UPDATE_DRAFT_CONFIGURATION_ERROR`;
export const UPDATE_DRAFT_CONFIGURATION_EMPTY = `UPDATE_DRAFT_CONFIGURATION_EMPTY`;

// DOWNLOAD PRICE FILE
export const DOWNLOAD_PRICE_FILE = `DOWNLOAD_PRICE_FILE`;
export const DOWNLOAD_PRICE_FILE_SUCCESS = `DOWNLOAD_PRICE_FILE_SUCCESS`;
export const DOWNLOAD_PRICE_FILE_ERROR = `DOWNLOAD_PRICE_FILE_ERROR`;
export const DOWNLOAD_PRICE_FILE_EMPTY = `DOWNLOAD_PRICE_FILE_EMPTY`;

// DOWNLOAD PRICE FILE
export const UPLOAD_PRICE_FILE = `UPLOAD_PRICE_FILE`;
export const UPLOAD_PRICE_FILE_SUCCESS = `UPLOAD_PRICE_FILE_SUCCESS`;
export const UPLOAD_PRICE_FILE_ERROR = `UPLOAD_PRICE_FILE_ERROR`;
export const UPLOAD_PRICE_FILE_EMPTY = `UPLOAD_PRICE_FILE_EMPTY`;

// GET ONBOARDING
export const GET_ONBOARDING_CONFIGURATION = `GET_ONBOARDING_CONFIGURATION`;
export const GET_ONBOARDING_CONFIGURATION_SUCCESS = `GET_ONBOARDING_CONFIGURATION_SUCCESS`;
export const GET_ONBOARDING_CONFIGURATION_ERROR = `GET_ONBOARDING_CONFIGURATION_ERROR`;
export const GET_ONBOARDING_CONFIGURATION_EMPTY = `GET_ONBOARDING_CONFIGURATION_EMPTY`;

// DOWNLOAD PRICE FILE
export const APPROVAL_ACTION_CONFIGURATION = `APPROVAL_ACTION_CONFIGURATION`;
export const APPROVAL_ACTION_CONFIGURATION_SUCCESS = `APPROVAL_ACTION_CONFIGURATION_SUCCESS`;
export const APPROVAL_ACTION_CONFIGURATION_ERROR = `APPROVAL_ACTION_CONFIGURATION_ERROR`;
export const APPROVAL_ACTION_CONFIGURATION_EMPTY = `APPROVAL_ACTIONFor_EMPTY`;

// GET LIVE CONFIG
export const GET_LIVE_CONFIG = `GET_LIVE_CONFIG`;
export const GET_LIVE_CONFIG_SUCCESS = `GET_LIVE_CONFIG_SUCCESS`;
export const GET_LIVE_CONFIG_ERROR = `GET_LIVE_CONFIG_ERROR`;
export const GET_LIVE_CONFIG_EMPTY = `GET_LIVE_CONFIG_EMPTY`;

// PUBLISH CONFIGURATION
export const PUBLISH_CONFIGURATION = `PUBLISH_CONFIGURATION`;
export const PUBLISH_CONFIGURATION_SUCCESS = `PUBLISH_CONFIGURATION_SUCCESS`;
export const PUBLISH_CONFIGURATION_ERROR = `PUBLISH_CONFIGURATION_ERROR`;
export const PUBLISH_CONFIGURATION_EMPTY = `PUBLISH_CONFIGURATION_EMPTY`;

// PUBLISH CONFIGURATION
export const PUBLISH_APPROVAL = `PUBLISH_APPROVAL`;
export const PUBLISH_APPROVAL_SUCCESS = `PUBLISH_APPROVAL_SUCCESS`;
export const PUBLISH_APPROVAL_ERROR = `PUBLISH_APPROVAL_ERROR`;
export const PUBLISH_APPROVAL_EMPTY = `PUBLISH_APPROVAL_EMPTY`;

// DOWNLOAD PRICE FILE
export const VALIDATE_ZONE = `VALIDATE_ZONE`;
export const VALIDATE_ZONE_SUCCESS = `VALIDATE_ZONE_SUCCESS`;
export const VALIDATE_ZONE_ERROR = `VALIDATE_ZONE_ERROR`;
export const VALIDATE_ZONE_EMPTY = `VALIDATE_ZONE_EMPTY`;

// DOWNLOAD PRICE FILE
export const GET_POLYGON_REGION = `GET_POLYGON_REGION`;
export const GET_POLYGON_REGION_SUCCESS = `GET_POLYGON_REGION_SUCCESS`;
export const GET_POLYGON_REGION_ERROR = `GET_POLYGON_REGION_ERROR`;
export const GET_POLYGON_REGION_EMPTY = `GET_POLYGON_REGION_EMPTY`;

// PUBLISH CONFIGURATION
export const REVOKE_CONFIGURATION = `REVOKE_CONFIGURATION`;
export const REVOKE_CONFIGURATION_SUCCESS = `REVOKE_CONFIGURATION_SUCCESS`;
export const REVOKE_CONFIGURATION_ERROR = `REVOKE_CONFIGURATION_ERROR`;
export const REVOKE_CONFIGURATION_EMPTY = `REVOKE_CONFIGURATION_EMPTY`;

// GET VENDOR
export const GET_VENDOR_LIST = `GET_VENDOR_LIST`;
export const GET_VENDOR_LIST_SUCCESS = `GET_VENDOR_LIST_SUCCESS`;
export const GET_VENDOR_LIST_ERROR = `GET_VENDOR_LIST_ERROR`;
export const GET_VENDOR_LIST_EMPTY = `GET_VENDOR_LIST_EMPTY`;

// GET PROJECT LIST
export const GET_PROJECT_LIST = `GET_PROJECT_LIST`;
export const GET_PROJECT_LIST_SUCCESS = `GET_PROJECT_LIST_SUCCESS`;
export const GET_PROJECT_LIST_ERROR = `GET_PROJECT_LIST_ERROR`;
export const GET_PROJECT_LIST_EMPTY = `GET_PROJECT_LIST_EMPTY`;

// UPLOAD CANCELATION FILE
export const UPLOAD_CANCELATION_FILE = `UPLOAD_CANCELATION_FILE`;
export const UPLOAD_CANCELATION_FILE_SUCCESS = `UPLOAD_CANCELATION_FILE_SUCCESS`;
export const UPLOAD_CANCELATION_FILE_ERROR = `UPLOAD_CANCELATION_FILE_ERROR`;
export const UPLOAD_CANCELATION_FILE_EMPTY = `UPLOAD_CANCELATION_FILE_EMPTY`;

// UPLOAD CANCELATION FILE
export const CANCELLED_WITH_VENDOR = `CANCELLED_WITH_VENDOR`;
export const CANCELLED_WITH_VENDOR_SUCCESS = `CANCELLED_WITH_VENDOR_SUCCESS`;
export const CANCELLED_WITH_VENDOR_ERROR = `CANCELLED_WITH_VENDOR_ERROR`;
export const CANCELLED_WITH_VENDOR_EMPTY = `CANCELLED_WITH_VENDOR_EMPTY`;
